import React from "react";
import styles from "./learningToolModal.module.css";

const LearningToolModal = ({
  message,
  approveBtnText,
  cancelBtnText,
  show,
  onClose,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2>Confirmation</h2>
        <p>{message}</p>
        <div className={styles.modalButtons}>
          <button className={styles.confirmationBtn} onClick={onConfirm}>
            {approveBtnText}
          </button>
          <button className={styles.cancelBtn} onClick={onClose}>
            {cancelBtnText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LearningToolModal;
